import * as React from "react";
import { ITransaction } from "./ITransaction";
import { DataTable } from "../ui";
import { FEE_MAINNET, FEE_TESTNET } from "../Block";

export function Outputs({ transaction }: { transaction: ITransaction }) {
  if (!transaction) return null;
  const url = "index.html?route=ADDRESS&address=";
  return (
    <DataTable
      headers={["Address", "Value"]}
      rows={transaction.vout.map((item: any) => {
        if (!item.scriptPubKey) {
          return ["—", item.value];
        }
        const addy =
          item.scriptPubKey.address ||
          (item.scriptPubKey.addresses && item.scriptPubKey.addresses[0]);
        if (!addy) {
          return ["OP_RETURN", "nulldata"];
        }
        const fee = addy === FEE_TESTNET || addy === FEE_MAINNET;
        let amount = item.value.toLocaleString() + " TLS";
        const asset = item.scriptPubKey.asset;
        if (asset) amount = asset.amount.toLocaleString() + " " + asset.name;
        return [
          <span>
            <a className="mono" href={url + addy}>
              {addy}
            </a>{" "}
            {fee ? <span className="tag fee">dev fee</span> : null}
          </span>,
          amount,
        ];
      })}
    />
  );
}
